import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import cx from 'classnames'
import Fade from '@material-ui/core/Fade'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'

const SearchHelper = ({ searchHelperVisible, setSearchHelperVisible }) => (
  <Fade in={searchHelperVisible} timeout={600}>
    <div className='absolute -bottom5 pa6 left-50 x--50-y-100 shadow-8-04 w16-l w-100 bg-white z5'>
      <CloseIconButton {...{ setSearchHelperVisible }} />
      <h2 className='db tc mh0 mt0 ph0 pt0 pb5 bb-medium b--cadet-blue f4 lh-solid'>
        Search Tips
      </h2>
      <SearchTips />
    </div>
  </Fade>
)

const CloseIconButton = ({ setSearchHelperVisible }) => (
  <IconButton
    classes={{ root: 'absolute right3 top3' }}
    size='small'
    onClick={() => setSearchHelperVisible(false)}
  >
    <CloseIcon />
  </IconButton>
)

const SearchTips = () => {
  const searchTips = [
    'Use quotation marks to search for exact words or phrases eg, "share buyback"',
    'Use quotation marks around all required search words and phrases to return results with all those exact words and phrases eg, "defective" "share buyback"',
    'Synonyms and acronyms are applied to search terms unless quotation marks are used',
    'Search will not correct typographical errors'
  ]

  return (
    <ul className='flex flex-wrap ma0 pa0'>
      {searchTips.map((searchTip, index) => (
        <li
          key={index}
          className={cx(
            'w-100 w-50-l mb4 flex',
            { 'pr5-l': index % 2 === 0 },
            { 'pl5-l': index % 2 === 1 }
          )}
        >
          <ArrowRightIcon />
          <span className='lh-title'>{searchTip}</span>
        </li>
      ))}
    </ul>
  )
}

export default SearchHelper
